// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import promise from 'es6-promise'
promise.polyfill()
import Vue from 'vue'
import HomeApp from './HomeApp.vue'
import i18n from './lang'
import router from './router/home.index'
import rum from './tool/rum'
import Tracker from './tool/ta'
import store from './store'
import axios from 'axios'
import toastPlugin from './tool/toast/toast'
import './registerServiceWorker'
import './assets/styles/index.less'
// 加载游戏特殊UI，实现游戏特殊UI的样式覆盖
import '@gameAssets/index.less'
import ENUM from './enum'
import installComponents from './tool/installComponents'
import utils from './tool/utils'
import filter from './filter'
import directive from './directive'
// 添加全局组件 $dialog方式
import { $dialog } from 'components'
Vue.use($dialog)
Vue.use(directive)

Vue.use(Tracker, {
  appId: process.env.VUE_APP_TGA_APPID,
  zoneOffset: parseInt(process.env.VUE_APP_TA_ZONE_OFFSET || 0),
})
Vue.use(rum, {})

Vue.use(toastPlugin)

Vue.use(installComponents)
Vue.prototype.$enum = ENUM
Vue.prototype.$utils = utils
Vue.use(filter)

axios.defaults.withCredentials = true
//axios.defaults.headers['x-requested-with'] = 'new'

Vue.config.errorHandler = function (err, vm, info) {
  console.error(err)
  vm.$rum.errorReport(err, vm, info)
}

/* eslint-disable no-new */
let wshop = new Vue({
  store,
  router,
  i18n,
  components: { HomeApp },
  template: '<HomeApp/>',
  data: {
    Bus: new Vue(),
  },
  render: (h) => h(HomeApp),
}).$mount('#app')

export default wshop
